import React from 'react';

const Help = () => {
    return (
        <div className="space-y-6">
            <div className="border-b pb-4">
                <h3 className="text-lg font-semibold text-gray-800 mb-2">Field Service Jobs</h3>
                <p className="text-sm text-gray-600">
                    Manage and schedule service tasks, repairs, and assignments.
                </p>
            </div>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">Creating Jobs</h4>
                <ul className="list-disc pl-5 space-y-2 text-sm text-gray-600">
                    <li>Click <strong>Add Job</strong> to schedule a new task.</li>
                    <li>Define the <strong>Type</strong> of service, <strong>Location</strong>, and <strong>Expected Times</strong>.</li>
                    <li>Add <strong>Notes</strong> to provide specific instructions to the technician.</li>
                </ul>
            </section>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">Tracking Progress</h4>
                <ul className="list-disc pl-5 space-y-2 text-sm text-gray-600">
                    <li>Monitor job <strong>Statuses</strong> (e.g., Pending, In Progress, Completed).</li>
                    <li>Use the <strong>Search Bar</strong> to filter jobs by name or location.</li>
                </ul>
            </section>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">Operational Reports</h4>
                <ul className="list-disc pl-5 space-y-2 text-sm text-gray-600">
                    <li>Select jobs to export detailed service reports in <strong>PDF</strong> or <strong>CSV</strong> format.</li>
                </ul>
            </section>
        </div>
    );
};

export default Help;
